export class InvalidUserPoolConfigError extends Error {
  constructor() {
    super(
      'Invalid user pool configuration. Make sure JSON web keys for your user pool are added to user-pool-config.ts'
    );
  }
}
